import { logError } from "@src/appV2/lib/analytics";
import { setPreference } from "@src/appV2/NativeAdapters/preferences.adapter";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";

interface PreferenceRequest {
  key: string;
  value: string;
}

export function useSetPreference(
  options: UseMutationOptions<void, Error, PreferenceRequest> = {}
): UseMutationResult<void, Error, PreferenceRequest> {
  return useMutation(["preferences"], {
    mutationFn: async (data: PreferenceRequest) => {
      try {
        await setPreference(data.key, data.value);
      } catch (error) {
        logError("Error setting preference:", {
          error,
          metadata: {
            key: data.key,
            value: data.value,
          },
        });
        throw error;
      }
    },
    ...options,
  });
}
